import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { usePostingStore } from '../lib/store/usePostingStore';
import ProgressHeader from '../components/posting/ProgressHeader';
import CoachMarksTour from '../components/posting/CoachMarksTour';
import Step1UploadPlatforms from '../components/posting/Step1UploadPlatforms';
import Step2MediaOptions from '../components/posting/Step2MediaOptions';
import Step3CaptionAutomations from '../components/posting/Step3CaptionAutomations';
import Step4SchedulePreview from '../components/posting/Step4SchedulePreview';
import Step5ReviewPublish from '../components/posting/Step5ReviewPublish';

const MultiPlatformComposer: React.FC = () => {
  const { currentStep, reset } = usePostingStore();
  
  // Reset store when component unmounts
  useEffect(() => {
    return () => {
      // Uncomment to reset store on unmount
      // reset();
    };
  }, []);

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1UploadPlatforms />;
      case 2:
        return <Step2MediaOptions />;
      case 3:
        return <Step3CaptionAutomations />;
      case 4:
        return <Step4SchedulePreview />;
      case 5:
        return <Step5ReviewPublish />;
      default:
        return <Step1UploadPlatforms />;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-6xl mx-auto"
    >
      <div className="flex items-center space-x-4 mb-6 px-6 py-4">
        <Link to="/dashboard" className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Multi-Platform Composer</h1>
          <p className="mt-1 text-gray-600 dark:text-gray-400">
            Create and publish content across multiple platforms in one go
          </p>
        </div>
      </div>

      <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm p-8 sm:p-10 lg:p-12">
        <ProgressHeader />
        {renderCurrentStep()}
      </div>
      
      <CoachMarksTour />
    </motion.div>
  );
};

export default MultiPlatformComposer;